// extracted by mini-css-extract-plugin
module.exports = {"root":"OnboardingHeading_root__tWp7G","headerWithButton":"OnboardingHeading_headerWithButton__2BTeN"};